import { getMetadata } from '../selectors/metadata';

import { useAppSelector } from './redux';

export const useMetadata = () => useAppSelector(getMetadata);
